const playingCardData = [
    {
        index: 0,
        name: "cardKing",
        match: "cardKingPair",
        cardText: "KING"     
    },
    {
        index: 1,
        name: "cardTwo",
        match: "cardTwoPair",
        cardText: "TWO"     
    },
    {
        index: 2,
        name: "cardNine",
        match: "cardNinePair",
        cardText: "NINE"     
    },
    {
        index: 3,
        name: "cardJack",
        match: "cardJackPair",
        cardText: "JACK"     
    },
    {
        index: 4,
        name: "cardKingPair",
        match: "cardKing",
        cardText: "KING"     
    },
    {
        index: 5,
        name: "cardNinePair",
        match: "cardNine",
        cardText: "NINE"     
    },
    {
        index: 6,
        name: "cardSix",
        match: "cardSixPair",
        cardText: "SIX"     
    },
    {
        index: 7,
        name: "cardQueen",
        match: "cardQueenPair",
        cardText: "QUEEN"     
    },
    {
        index: 8,
        name: "cardJackPair",
        match: "cardJack",
        cardText: "JACK"     
    },
    {
        index: 9,
        name: "cardAce",
        match: "cardAcePair",
        cardText: "ACE"     
    },
    {
        index: 10,
        name: "cardQueenPair",
        match: "cardQueen",
        cardText: "QUEEN"     
    },
    {
        index: 11,
        name: "cardAcePair",
        match: "cardAce",
        cardText: "ACE"     
    },
    {
        index: 12,
        name: "cardSixPair",
        match: "cardSix",
        cardText: "SIX"     
    },
    {
        index: 13,
        name: "cardTwoPair",
        match: "cardTwo",
        cardText: "TWO"     
    }
]

export default playingCardData